import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function SearchHelpDialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Search an item</DialogTitle>
      <DialogContent>
        <Typography>
          You can search for any keywords located in the name, notes, category or tags.
          Additionally, you can search for a dimension range using a combination of a special syntax
          for [w]idth, [d]epth and [h]eight.
        </Typography>
        <Typography sx={{ mt: 1.5 }}>
          The min and max boundaries are optional, you can specify both or only one of them. The
          order of the search terms is not relevant.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Syntax:</Typography>
          <Box
            component="pre"
            sx={{
              bgcolor: "grey.100",
              p: 1.5,
              borderRadius: 1,
              fontSize: 13,
              mt: 0.5,
              overflowX: "auto",
              whiteSpace: "pre-wrap",
            }}
          >
            {"![min][w or d or h][max]!"}
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Example:</Typography>
          <Box
            component="pre"
            sx={{
              bgcolor: "grey.100",
              p: 1.5,
              borderRadius: 1,
              fontSize: 13,
              mt: 0.5,
              overflowX: "auto",
              whiteSpace: "pre-wrap",
            }}
          >
            {"!20w40! !22.5d! !h50! glass chrome"}
          </Box>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Finds items with width 20–40, depth ≥ 22.5, height ≤ 50, containing "glass" and
            "chrome".
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
